import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '@deal/components'
import BrandAwareLogo from '#src/components/Logo'
import PageContent from '#src/components/PageContent'
import { ContentfulImage } from '#src/containers/Contentful'
import Help from './help.svg'
import styles from './styles.css'

interface Props {
  backgroundImage: ContentfulImage
  backgroundImagePosition: string
  headline: string
  subHeadline: string
}

const Background: React.SFC<Props> = ({
  children,
  backgroundImage,
  backgroundImagePosition = '50% 50%',
  headline,
  subHeadline
}) => (
  <div className={styles.mainContainer}>
    {backgroundImage &&
      backgroundImage.imageUrl && (
        <Image
          src={backgroundImage.imageUrl}
          sizes="100vw"
          className={styles.heroImage}
          htmlAttributes={{
            style: {
              objectPosition: backgroundImagePosition
            }
          }}
        />
      )}
    <nav className={styles.nav}>
      <PageContent className={styles.navContent}>
        <Link to="/">
          <BrandAwareLogo color="light" />
        </Link>
        <Link to="/support" className={styles.navRight}>
          <Help />
          <div className={styles.navTitle}>Help and Advice</div>
        </Link>
      </PageContent>
    </nav>
    <PageContent>
      <div className={styles.layoutContainer}>
        <div className={styles.layoutHeader}>
          <div className={styles.layoutTitle}>{headline}</div>
          <div className={styles.layoutSubtitle}>{subHeadline}</div>
        </div>
        {children}
      </div>
    </PageContent>
  </div>
)

export default Background
